import { Namespace } from 'library/ts/namespaces/Namespace';
import { TagDataService } from 'plugins/tag/plugin_data_service/ts/Application/TagDataService';

export {};

declare global {
	interface Window {
		[ Namespace.TAG_DATA_SERVICE ]: typeof TagDataService; // declare class in global namespace
	}
}

window[ Namespace.TAG_DATA_SERVICE ] = TagDataService;